import { createSelector } from 'reselect'
import userProductSelector from 'redux/selectors/user/user_product_selector'
import productTypes from 'helpers/enums/productTypes'

const userHasDistrictProductSelector = createSelector(
	[userProductSelector],
	product => product === productTypes.DISTRICT
)

export default userHasDistrictProductSelector
